"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersServiceImpl = void 0;
const moment_1 = __importDefault(require("moment"));
class OrdersServiceImpl {
    constructor(proxyService) {
        this.proxyService = proxyService;
    }
    getOrdersByDate(ordersByDateArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.proxyService
                .getOrdersByDate(ordersByDateArgs)
                .then((ordersPaginated) => {
                var _a, _b, _c;
                if (ordersPaginated && ordersPaginated.orders) {
                    for (const order of ordersPaginated.orders) {
                        let latestDate;
                        for (const item of order.items) {
                            if ((_a = item.extension_attributes) === null || _a === void 0 ? void 0 : _a.order_item_extra_shipping_info) {
                                if ((_b = item.extension_attributes) === null || _b === void 0 ? void 0 : _b.order_item_extra_shipping_info) {
                                    try {
                                        const newDate = (0, moment_1.default)((_c = item.extension_attributes) === null || _c === void 0 ? void 0 : _c.order_item_extra_shipping_info, "YYYY/MM/DD");
                                        if (!latestDate || latestDate.isBefore(newDate)) {
                                            latestDate = newDate;
                                        }
                                    }
                                    catch (_d) { }
                                }
                            }
                        }
                        order.latestItemShippingDate =
                            latestDate && latestDate.format("YYYY-MM-DD");
                    }
                }
                return ordersPaginated;
            })
                .catch((error) => {
                throw error;
            });
        });
    }
    getOrdersById(ordersByIdArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.proxyService
                .getOrdersById(ordersByIdArgs)
                .then((orderPaginated) => {
                return orderPaginated;
            })
                .catch((error) => {
                throw error;
            });
        });
    }
    getOrders(ordersArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.proxyService
                .getOrders(ordersArgs)
                .then((orders) => {
                return orders;
            })
                .catch((error) => {
                throw error;
            });
        });
    }
    getOrder(orderArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.proxyService
                .getOrder(orderArgs)
                .then((orders) => {
                return orders;
            })
                .catch((error) => {
                throw error;
            });
        });
    }
    getInvoicesByOrderId(orderId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.proxyService
                .getInvoicesByOrderId(orderId)
                .then((invoices) => {
                return invoices;
            })
                .catch((error) => {
                throw error;
            });
        });
    }
    getProductImage(productImageBySkuArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.proxyService
                .getProductImage(productImageBySkuArgs)
                .then((image) => {
                return image;
            })
                .catch((error) => {
                throw error;
            });
        });
    }
    getShippingStatus(orderStatusArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.proxyService
                .getShippingStatus(orderStatusArgs)
                .then((image) => {
                return image;
            })
                .catch((error) => {
                throw error;
            });
        });
    }
    getInvoicesIncrementIdByOrderId(orderId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.proxyService
                .getInvoicesByOrderId(orderId)
                .then((invoices) => invoices && invoices.invoices.map((i) => i.increment_id))
                .catch((error) => {
                throw error;
            });
        });
    }
}
exports.OrdersServiceImpl = OrdersServiceImpl;
//# sourceMappingURL=ordersServiceImpl.js.map